
import { ItemMenu } from "../../../../../../components/baseMenu";
import { DestinationMenuItem } from "../activityRegister/utils/enum/destinationMenu";
import { ConvertDestination, DeleteDestination, EditDestination } from "./types";

export const menuOptionsDestination = ({
    item,
    payload
}: {
    item: ItemMenu,
    payload?: {
        id: number;
        name: string;
        createdDate: string;
        userCreator: string;
        direction: string;
        latitudeAndLongitude: string;
        companyName: string;
        companyId: number;
        deleteDestination: DeleteDestination,
        editDestination: EditDestination,
        converDestination: ConvertDestination,
    }
}) => {

    switch (item.value) {
        case DestinationMenuItem.EDIT: {
            if (payload?.id) {
                payload.editDestination({
                    companyId: payload.companyId,
                    companyName: payload.companyName,
                    direction: payload.direction,
                    id: payload.id,
                    latitudeAndLongitude: payload.latitudeAndLongitude,
                    name: payload.name
                })
            }
            break
        }
        case DestinationMenuItem.CONVERT: {
            if (payload?.id) {
                payload.converDestination({
                    companyId: payload.companyId,
                    companyName: payload.companyName,
                    direction: payload.direction,
                    id: payload.id,
                    latitudeAndLongitude: payload.latitudeAndLongitude,
                    name: payload.name
                })
            }
            break
        }
        case DestinationMenuItem.DELETE: {
            if (payload?.id) {
                payload.deleteDestination({ id: payload.id })
            }
            break

        }
    }
}